import React, { useState, useEffect } from 'react'
import { Column } from 'react-virtualized'

import Table from '../../../containers/Tables/components/Table'
import TableStyles from '../../../containers/Tables/components/Table/Table.css'
import TableHeader from '../../../containers/Tables/components/TableHeader'
import styles from './NotificationRemaindersTable.css'
import { REMAINDERS_TABLE_COLUMN_HEADERS } from '../../../constants'
import { customCellRenderer } from '../../../../views/components/Table/CellRenderers'
import { useIntl } from 'react-intl'
import { formatRemainderListData } from './Utilities'

const ROW_HEIGHT = 50
const REMAINDER_WIDTH = 264
const PERIOD_WIDTH = 200
const CONDITIONS_WIDTH = 250
const MESSAGE_WIDTH = 500

/**
 * It generates columns based on column config
 */
const renderColumns = intl => {
  const COLUMN_CONFIG = [
    {
      width: REMAINDER_WIDTH,
      dataKey: REMAINDERS_TABLE_COLUMN_HEADERS.REMAINDER,
    },
    {
      width: PERIOD_WIDTH,
      dataKey: REMAINDERS_TABLE_COLUMN_HEADERS.PERIOD,
    },
    {
      width: CONDITIONS_WIDTH,
      dataKey: REMAINDERS_TABLE_COLUMN_HEADERS.CONDITIONS,
    },
    {
      width: MESSAGE_WIDTH,
      dataKey: REMAINDERS_TABLE_COLUMN_HEADERS.MESSAGE,
    },
  ]
  return COLUMN_CONFIG.map(({ width, dataKey, intlKey }) => (
    <Column
      key={dataKey}
      width={width}
      className={TableStyles.column}
      label={
        intlKey
          ? intl.formatMessage({
            id: intlKey,
          })
          : dataKey
      }
      dataKey={dataKey} // not needed but field required by library
      disableSort={true}
      headerRenderer={headerProps => {
        const { label } = headerProps

        return (
          <TableHeader
            label={label}
            columnHeader={dataKey}
            enableSort={false}
          />
        )
      }}
      cellRenderer={customCellRenderer}
    />
  ))
}
const NotificationRemaindersTable = props => {
  const [ tableData, setTableData ] = useState([])
  const {
    noDataText = 'There are no remainders available.',
    enableLoader,
    showLoader,
    data,
    me,
  } = props
  const intl = useIntl()

  useEffect(() => {
    if (
      me &&
      me.data &&
      me.data.teams &&
      me.data.teams.length > 0 &&
      Object.prototype.hasOwnProperty.call(
        me.data.teams[0],
        'notificationTemplates',
      ) &&
      me.data.teams[0].notificationTemplates.length > 0
    ) {
      setTableData(
        formatRemainderListData(me.data.teams[0].notificationTemplates[0]),
      )
    }
  }, [ me ])

  return (
    <div
      className={styles.notificationRemaindersTable}
      data-page="notification-remainders-table"
      data-value={showLoader ? null : data.length}
    >
      <Table
        noDataText={noDataText}
        enableLoader={enableLoader}
        showLoader={showLoader}
        rowHeight={ROW_HEIGHT}
        uniqueKey="id"
        data={tableData}
        headerHeight={50}
      >
        {renderColumns(intl)}
      </Table>
    </div>
  )
}

export default NotificationRemaindersTable



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/NotificationRemaindersTable/NotificationRemaindersTable.jsx